import React, { useEffect, useState } from 'react';
import { Dialog, TextInput, Text } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function DeleteBranchDialog(props) {
  const {
    show,
    onClose,
    onDelete,
    delegate
  } = props;
  const [branch, setBranch] = useState('');
  const [affected, setAffected] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const execute = async () => {
      setLoading(true);
      try {
        const res = await GlobalState.dispatch(delegate.item(branch).list({
          limit: 0
        }));
        setAffected(res.total);
      } catch (err) {
        setAffected(0);
      }
      setLoading(false);
    };
    if (branch?.length) {
      execute();
    }
  }, [branch]);
  const message = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Text, {
      children: ["Are you sure you want to delete all of the rsrcs at path ", branch, "? This action will delete ", affected || 0, " rsrc", affected === 1 ? '' : 's', " and cannot be reversed."]
    }), /*#__PURE__*/_jsx(TextInput, {
      value: branch,
      onChange: ({
        value
      }) => setBranch(value)
    })]
  });
  const onOkay = async () => {
    await onDelete(branch);
    onClose();
  };
  return /*#__PURE__*/_jsx(Dialog.Question, {
    onOkay: onOkay,
    okayDisabled: branch.length < 1 || loading,
    onCancel: onClose,
    show: show,
    title: "Delete Branch of Rsrcs",
    okay: "Delete",
    okayVariant: "primaryDestructive",
    children: message
  });
}